import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as AppState from '../../../../../state/app.state';
import { AppHeaderState } from './app-header.reducer';

export interface State extends AppState.State {
    appHeader: AppHeaderState;
}

const getAppHeaderFeatureState = createFeatureSelector<AppHeaderState>('appHeader');

export const getBcsNotifications = createSelector(
    getAppHeaderFeatureState,
    state => state.bcsNotifications
);
